import React, { Component } from 'react';
import { Button, Tooltip, Intent } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import QuestionnaireEditAnswerDrawer from 'containers/Manage-Questionnaire/questionnaire/QuestionnaireEditAnswerDrawer';
import { DialogWrapper } from 'components/DialogWrapper';
import { archiveQuestionnaireAnswer } from 'api/questionnaire';
import { AppToaster } from 'components/AppToaster';
import { TableData, TableDataIcons } from 'components/styled-components';
import { TableRow } from 'containers/Manage-Questionnaire/styled-components';
import { statusByVersionStatus } from 'utils/functions';

class Row extends Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false, removeAnswer: false };
  }
  openDrawer = () => this.setState({ isOpen: true });
  closeDrawer = () => this.setState({ isOpen: false });
  handleDismissRemoveAnswer = () => this.setState({ removeAnswer: false });
  openRemoveAnswerDialog = () => this.setState({ removeAnswer: true });

  handleArchiveAnswer = (id, status) => {
    archiveQuestionnaireAnswer(id, status)
      .then(res => {
        AppToaster.show({
          message: res.data.message,
          intent: Intent.SUCCESS,
        });
        this.props.fetchQuestionnaireQuestions();
        this.handleDismissRemoveAnswer();
      })
      .catch(err => {
        AppToaster.show({
          message: err.response.data.message,
          intent: Intent.DANGER,
        });
        this.handleDismissRemoveAnswer();
      });
  };

  render() {
    const { answer, isLastAnswer } = this.props;
    const status = statusByVersionStatus(answer.versionStatus);

    return (
      <>
        <TableRow key={answer.answerID}>
          <TableData>{answer.answerID}</TableData>
          <TableData>{answer.answer}</TableData>
          <TableData>{answer.score}</TableData>
          <TableData>{answer.autoFail ? 'Yes' : 'No'}</TableData>
          <TableDataIcons>
            <Tooltip content="Edit">
              <Button
                icon={IconNames.EDIT}
                minimal={true}
                onClick={this.openDrawer}
              />
            </Tooltip>
          </TableDataIcons>
          <TableDataIcons>
            {!isLastAnswer && (
              <Tooltip content={'Remove'}>
                <Button
                  icon={IconNames.TRASH}
                  onClick={this.openRemoveAnswerDialog}
                  minimal
                />
              </Tooltip>
            )}
          </TableDataIcons>
        </TableRow>
        <QuestionnaireEditAnswerDrawer
          isOpen={this.state.isOpen}
          closeDrawer={this.closeDrawer}
          answer={answer}
          {...this.props}
        />
        <DialogWrapper
          isOpen={this.state.removeAnswer}
          onClose={this.handleDismissRemoveAnswer}
          title={'Remove Answer'}
          body={status.getBodyAnswer}
          confirm={'REMOVE'}
          action={
            this.props.newQuestion
              ? () => {
                  this.props.archiveLocalAnswer(this.props.index);
                  this.props.closeDrawer();
                }
              : () =>
                  this.handleArchiveAnswer(
                    answer.answerID,
                    answer.versionStatus
                  )
          }
        />
      </>
    );
  }
}

export default Row;
